'use strict';

var appConfig = require('@valenzinsights/app-config');
var utils = require('@valenzinsights/utils');

function t(){return new utils.ApiClient(appConfig.endpoints.backendApiUrl)}function o(){return new utils.ApiClient(appConfig.endpoints.backendMockApiUrl)}

exports.a = t;
exports.b = o;
